import * as TYPES from '../constants';

import { BreadcrumbType } from 'components/Breadcrumb';
import { store } from 'store';
import strings from 'utils/strings';

export const setLoader = (value: boolean) => ({ type: TYPES.SET_LOADER, value });
export const setTitle = (value: string) => ({ type: TYPES.SET_TITLE, value });
export const setUser = (value: object) => ({ type: TYPES.SET_USER, value });
export const setBusiness = (value: object) => ({ type: TYPES.SET_BUSINESS, value });
export const setToken = (value: string) => ({ type: TYPES.SET_TOKEN, value });
export const setMobile = (value: boolean) => ({ type: TYPES.SET_MOBILE, value });
export const setNav = (value: boolean) => ({ type: TYPES.SET_NAV, value });
export const setLogout = () => ({ type: TYPES.SET_LOGOUT });
export const setUpdater = (dispatch: any) => ({ type: TYPES.SET_UPDATER, dispatch });
export const setLanguage = (value: string) => {
	strings.setLanguage(value);
	return { type: TYPES.SET_LANGUAGE, value };
}
export const setNotificationToken = (value: string) => ({ type: TYPES.SET_NOTIFICATION_TOKEN, value });
export const setFirebaseNotifications = (value: boolean) => ({ type: TYPES.SET_FIREBASE_NOTIFICATIONS, value });
export const setUnreadChatMessages = (value: boolean) => ({ type: TYPES.SET_UNREAD_MESSAGES, value });
export const setPagesModal = (value: string) => ({ type: TYPES.SET_PAGES_MODAL, value });
export const setBreadcrumb = (value: BreadcrumbType | null) => ({ type: TYPES.SET_BREADCRUMB, value });
export const updateCrumb = () => ({ type: TYPES.UPDATE_CRUMB });

// DND: `until` is a UTC timestamp in ms, null when inactive
export const setDnd = (value: { until: number | null }) => ({ type: TYPES.SET_DND, value });

// VIDEO CALLS
export const setVideoSettings = (value: any) => ({ type: TYPES.SET_VIDEO_SETTINGS, value });
export const setRoom = (value: any) => ({ type: TYPES.SET_ROOM, value });
export const setPendingCalls = (value: any) => ({ type: TYPES.SET_PENDING_CALLS, value });

// AUDIO CALLS
export const setAudioSettings = (value: any) => ({ type: TYPES.SET_AUDIO_SETTINGS, value });
export const setAudioRoom = (value: any) => ({ type: TYPES.SET_AUDIO_ROOM, value });

export const delayedDispatch = (value: any, time = 400) => {
	setTimeout(() => store.dispatch(value), time);
}

// CHAT
export const setPendingMessages = (value: any) => ({ type: TYPES.SET_PENDING_MESSAGES, value });
export const setPendingChats = (value: any) => ({ type: TYPES.SET_PENDING_CHATS, value });
export const setAcceptedChat = (value: any) => ({ type: TYPES.SET_ACCEPTED_CHAT, value });
export const setFinishedChat = (value: any) => ({ type: TYPES.SET_FINISHED_CHAT, value });
export const setToDelete = (value: any) => ({ type: TYPES.SET_TO_DELETE_CHAT, value });